// 按页面划分
export default {
    // 公共页面
    "common": {
        "title": "Gagnaverslun",
        "pull_refresh": "Dragðu niður í hressingu",
        "release_refresh": "Slepptu til að hressa",
        "refresh_loading": "Hleðsla ...",
        "footer_text": "Þjónustur eru veittar af Ucloudlink (NASDAQ: UCL)"
    },
    "home": {
        "input_placeholder": "Leitarland/svæði",
        "my_flow": "Gögnin mín",
        "charge_code": "Skírteini kóða",
        "coupons": "Afsláttarmiða",
        "local_package": "Staðbundin gögn",
        "more": "Meira",
        "popular_destination": "Land/svæði",
        "buy_now": "Kauptu núna",
        "package_useing": "Virkur",
        "unused": "Óvirkur",
        "download_app": "Sæktu appið",
        "enter_the_mall_list": "Farðu í verslunarmiðstöðina",
        "no_data": "Engin gögn ennþá",
        "no_data_available": "Engin gögn tiltæk",
        "copy_success": "Afritun tókst",
        "copy_fail": "Afritun mistókst",
        "meritsTitle": "Hvað eru kostirnir?",
        "merits1": "Engin SIM krafist & Engar mánaðargjöld",
        "merits2": "Samþætt við 2-3 efstu netveitur fyrir sjálfvirka netskiptingu.",
        "go_buy": "Farðu að kaupa",
        "instant_savings": "Sparðu",
        "expires_in": "Rennur út eftir",
        "download_app_tips": "Sækjið forritið til að fá fleiri tilboð og upplifanir"
    },
    "packages": {
        "sub_title": {
            "us": "Að undanskildum Guam, Saipan",
            "it": "Þar á meðal Vatíkanborg, San Marino",
            "va": "Þar á meðal Ítalía, San Marino",
            "sm": "Þar á meðal Ítalía, Vatíkanborg",
            "ma": "Þar á meðal Vestur -Sahara",
            "eh": "Þar á meðal Marokkó",
            "ch": "Þar á meðal Liechtenstein",
            "li": "Þar á meðal Sviss",
            "fr": "Þar á meðal Mónakó",
            "mc": "Þar á meðal Frakkland",
            "fi": "Þar á meðal Aland -eyjar",
            "ax": "Þar á meðal Finnland",
            "gu": "Þar á meðal Norður -Mariana -eyjar",
            "mp": "Þar á meðal Guam"
        },
        "unlimited_packages": "Ótakmarkaður gagnapakki",
        "normal_packages": "Venjulegur gagnapakki",
        "multi_region_packages": "Fjölsvæðið",
        "regional_data": "Svæðisdæmi",
        "high_speed_text": "Háhraða gögn",
        "infiniteFlow": "Ótakmarkað gögn",
        "unLimitData": "Ótakmarkað",
        "high_speed_text_year": "Háhraði/þingmaður",
        "package_list": "Listi pakka",
        "special_offer": "Afslætti",
        "first_month": "1. Mánuður",
        "periodUnit": {
            "day": "Dagur",
            "month": "Mánuður",
            "hour": "klukkustund",
            "year": "ár"
        },
        "periodUnits": {
            "day": "Dagur",
            "month": "mánuðir",
            "hour": "klukkustund",
            "year": "ár"
        },
        "periodUnitSimp": {
            "day": "D.",
            "month": "fyrir",
            "hour": "h",
            "year": "The"
        },
        "periodUnitMonthly":"Mánaðarlegur",
        "periodUnitsSimp": {
            "day": "D.",
            "month": "fyrir",
            "hour": "h",
            "year": "The"
        },
        "unlimited_good_name": {
            "day": "Dagspass",
            "month": "Mánaðarlegt framhjá",
            "year": "Árlega framhjá"
        },
        "continuousMonth": "Samfelldir mánuðir",
        "continuousDay": "Stöðugir dagar",
        "continuousYear": "Samfelld ár",
        "day_invalid": "Renna út á núverandi degi",
        "month_invalid": "Renna út í yfirstandandi mánuði",
        "immediate_valid": "Árangursrík strax",
        "tomorrow_day_valid": "Árangursrík frá næsta degi",
        "tomorrow_month_valid": "Gildir frá næsta mánuði",
        "detail": {
            "cell_flow": "Gögn",
            "cell_period": "Gildi",
            "buy_quantity": "Upphæð",
            "use_area": "Umfjöllun",
            "use_intro": "Skilmála og skilyrði",
            "buy_btn": "Pöntun",
            "pay": "greiða",
            "buy_tips": "Þú ert að nota %@packageName-pakkið. Vilt þú kaupa þetta pakkið?",
            "haveOrderTips": "Pöntun með bíðandi greiðslu búin til. Smelltu á Staðfesta til að fara á gögnasíðuna mína！"
        },
        "confirm": {
            "title": "Staðfesting pöntunar",
            "real_pay_amount": "Fjárhæð greidd",
            "online_payment": "Greiðslu á netinu",
            "create_order_error": "Uppsetning mistókst"
        }
    },
    "pay": {
        "result": {
            "loading_order_status": "Að fá pöntunarstöðu ...",
            "buy_success": "Pöntun lokið",
            "buy_pending": "Í bið staðfestingar",
            "buy_pending_tip": "Greiðsla í vinnslu… Ef greiðsla varð ekki flutt innan 10 mínútna, vinsamlegast hafðu samband við okkur til stuðnings.",
            "get_payment_info_fail": "Greiðsluupplýsingar mistókst",
            "cell_package": "Pakki",
            "cell_buy_amount": "Subtotal",
            "cell_real_amount": "Fjárhæð greidd",
            "go_to_order_btn": "Farðu í pakkann minn",
            "back_home": "Aftur að heiman",
            "back_mall": "Aftur í verslunarmiðstöðina",
            "ordersn_empty": "Panta SN getur ekki verið tómt",
            "order_search_error": "Óvænt villa",
            "goodsName": 'Vöruheiti'
        },
        "fail": {
            "payment_fail": "Greiðsla mistókst",
            "back_home": "Aftur að heiman"
        }
    },
    "CountryGroup": {
        "title": "Land/svæði",
        "placeholder": "Leitarland eða svæði",
        "clear": "Tær",
        "history": "Leitarsaga"
    },
    "PromotionCode": {
        "verification": {
            "title": "Skírteini kóða",
            "minititle": "Skírteini kóða",
            "input": "Vinsamlegast sláðu inn toppinn",
            "explain": "Ábendingar: Snertu skannahnappinn efst til hægri til að skanna QR kóða skírteinisins, eða sláðu inn skírteinisnúmerið handvirkt (tilfelli) ef það virkar ekki.",
            "submit": "Sendu",
            "exchange": "Innleysa",
            "cancel": "Hætta við",
            "Inquiry": "Ertu viss um að skiptast á",
            "ErrorCode": "Endurhlaða villu"
        },
        "recharge_success": {
            "package": "Pakki",
            "content": "Tókst með góðum árangri",
            "back": "Aftur í verslunarmiðstöðina",
            "view_packets": "Farðu í pakkann minn"
        }
    },
    "order": {
        "state": {
            "inUse": "Virkt",
            "isFirst": "Prioriteetseks seatud",
            "toFirst": "Setja forgang",
            "inactive": "Inaktiveeritud"
        },
        "periodUnits": {
            "minute": "mínútu",
            "hour": "klukkustund",
            "day": "Dagur",
            "month": "mánuðir"
        },
        "useIntro": {
            "tip1": "Ótakmarkaður gagnapakki hefur meiri forgang en bindi gagnapakka.",
            "tip2": "Fyrir sama tegund af pakka, mun forgangur byggjast á kaupdegi, þ.e. pakkinn með fyrsta kaupdegi verður notaður fyrstur, en forgangur einstakra svæðapakka er hærri en svæðapakka.",
            "tip3": "Þú getur einnig aðlagað forgang handvirkt við að nota pakka af sömu gerð."
        },
        "myFlow": "Gögnin mín",
        "remainingFlow": "Gögn eftir",
        "remainingTime": "Gilt vinstri",
        "remainingHighFlow": "Háhraða gögn eftir",
        "validPeriod": "Gildi",
        "noneFlow": "Enginn gagnapakki",
        "noneFlowTip": "Vinsamlegast keyptu gagnapakkann og njóttu hágæða netsins",
        "buyPackFlow": "Kaupa pakka",
        "checkInvalidFlow": "Athugaðu útrunninn gagnapakka",
        "orderList": {
            "title": "pantanir mínar",
            "amount_paid": "Samtals",
            "device": "Tæki í eigu",
            "order_details": "Upplýsingar um pöntun",
            "total_amont": "Samtala subtotal",
            "orderSN": "Pöntun nr.",
            "createTime": "Sköpunartími",
            "cancelTime": "Lokaður tími",
            "payTime": "Pantunartími",
            "unsubTime": "Aflýstur tími",
            "payMethod": "Greiðslumáti",
            "thirdSN": "Viðskipti nr.",
            "delete": "Eyða",
            "cancel": "Hætta við pöntun",
            "unsub": "Endurgreiðsla",
            "goto_cancel": "Viltu hætta við pöntunina?",
            "goto_unsubscribe": "Viltu afskrá pöntunina?",
            "delete_Tips": "Ekki er hægt að halda pöntuninni áfram eftir að henni hefur verið eytt, því er ekki hægt að meðhöndla vandamál þín eftir þjónustu.Ertu viss um að eyða því?",
            "status_success": "Lokið",
            "status_pending": "Ógreitt",
            "status_cancel": "Lokað",
            "status_unsub": "Hætt við",
            "payMethod_stripe": "Kredittkort"
          },
    },
    "registerlogin": {
        "create_account_tip":"Búðu til reikning, byrjaðu einkarétt",
        "select_country_tip":"Tæki nota land/svæði",
        "email_name": "Póstur",
        "phone_name": "Sími",
        "email_address": "Netfang",
        "password": "Lykilorð",
        "country": "land",
        "select_country": "Veldu land",
        "cancel": "Hætta við",
        "confirm": "Jú",
        "please_enter": "Vinsamlegast sláðu inn 6-20 stafir (sambland af bókstöfum, tölum eða táknum)",
        "select_country_tips": "Landsval er til að skoða staðbundna pakka. Ekki er hægt að breyta því eftir skráningu. Vinsamlegast staðfestu!",
        "global_roaming": "Alþjóðlegur lénskóði",
        "phone_number": "símanúmer",
        "agree": "sammála",
        "user_agreement": "Notendasamningur",
        "and": "Og",
        "privacy_policy": "Persónuverndarstefna",
        "register_login": "Skráðu þig eða skráðu þig inn",
        "login_error": "Fjöldi innskráningar er of tíð, reyndu aftur seinna!",
        "register_error": "Fjöldi skráninga er of tíð, reyndu aftur seinna!",
        "forgot_pwd": "Gleymdu lykilorðinu",
        "app_tips": "Skráðu þig inn í appið með þessum reikningi eftir að hafa halað honum niður til að fá aðgang að fleiri aðgerðum.",
        "download_app": "Farðu til að hlaða niður appinu",
        "rememberPwd": "Mundu lykilorð",
        "third_login": "Haltu áfram með",
        "agreement_tips": "Vinsamlegast hakaðu við notendasamninginn og persónuverndarstefnu reitinn",
        "selectCountry_tips": "Vinsamlegast hafðu í huga að skráða landið mun hafa bein áhrif á eftirfarandi greiðslumáta og gjaldmiðla, vinsamlegast veldu í samræmi við þörf þína.",
        "login_error_cancel": "Notandinn hætti við skráningu",
        "login_error_auth": "Leyfðu popup glugga frá vafra stillingum",
        "device_tips": "Tæki bíður virkjunar. Meðhöndlun innan 24 klukkustunda."
    },
    "forgotPwd": {
        "forgot_pwd": "Gleymdu lykilorðinu",
        "email_address": "Netfang",
        "next": "Næst",
        "email_has_been_sent": "Við höfum sent tölvupóst á %@email. Vinsamlegast smelltu á hlekkinn og fylgdu skrefunum til að sækja lykilorðið þitt.",
        "have_retrieved_it": "Ég hef fundið það",
        "unable_to_receive_email": "Geturðu ekki fengið tölvupóstinn? Vinsamlegast athugaðu hvort það eru tölvupóstir frá %@email undir ruslpóstinum þínum og eytt póstskrá",
        "or": "eða",
        "resend": "Sendu aftur",
        "global_roaming": "Alþjóðlegur lénskóði",
        "phone_number": "símanúmer",
        "verification_code_has_been_sent": "Við höfum sent staðfestingarkóðann til:",
        "verification_code": "Staðfestingarkóði",
        "no_verification_code_received": "Fékk ekki staðfestingarkóðann?",
        "please_enter": "Vinsamlegast sláðu inn 6-20 stafir (sambland af bókstöfum, tölum eða táknum)",
        "reset_password": "Endurstilla lykilorð",
        "reset_successful": "Endurstilla með góðum árangri"
    },
    "coupons": {
        "coupons_name": "Afsláttarmiða",
        "no_coupons": "Engar afsláttarmiðar ennþá",
        "no_data": "Engin gögn ennþá",
        "applicable_to_the_following": "Afsláttarmiðar henta fyrir eftirfarandi gagnapakka"
    },
    "digital":{
        "title":"Tæki SN",
        "purchased":"Innkaupin mín",
        "viewAll":"Meira",
        "skinStore":"Vöruverslun",
        "completed":"Keypt",
        "goBuy":"Kaupa",
        "order": {
          "title":"Keyptar pantanir"
        },
        "detail": {
          "describe":"Lýsing"
        }
    },
    "viewPL": {
        "other": 'aðrir'
    },
    "invalidFlow": {
        "stateName": "Staða",
        "state": {
            "NOT_ACTIVATED": "Óvirkt",
            "IN_USING": "Laus",
            "USE_END": "Örmagna",
            "EXPIRE": "Útrunnið",
            "TRANSFER": "Flytja",
            "UNSUBSCRIBE": "Hætta við",
            "VALID": "Gilt",
            "INVALID": "Ógnvekjandi",
            "EXCHANGE_POINTS": "Innlausn stig"
        },
        "noneFlow": "Enginn útrunninn gagnapakki",
        "pageName": "Útrunninn gagnapakki"
    },
    "flowDetail": {
        "title": "Upplýsingar um gögn",
        "flow": "Gögn",
        "validTime": "Gild byrjun",
        "invalidTime": "Gilt þar til",
        "coverage": "Umfjöllun",
        "useIntro": "Skilmála og skilyrði",
        "purchaseTime": "Keypt kl",
        "subtotal": "subtotal",
        "status": "Staða",
        "cancel": "Hætta við",
        "buyAgain": "Kauptu það aftur",
        "validity": "Gildi",
        "tip": "Taktu eftir",
        "cancelTip": "Afsakaðu þennan pakka?",
        "dataLeft": "Gögn eftir"
    },
    "netError": {
        "try_again": "Reyndu aftur",
        "net_error": "Ekkert net",
        "try_again_desc": "Vinsamlegast athugaðu netstillinguna og reyndu aftur"
    },
    "loadFail": {
        "try_again": "Reyndu aftur",
        "load_fail": "Hleðsla mistókst",
        "load_fail_desc": "Gagnahleðsla mistókst, reyndu aftur",
        "IMEI_Not_Exist": "IMEI ekki til, vinsamlegast reyndu að slá inn frá réttum inngangi",
        "Project_Not_Exist": "Villa á sér stað. Vinsamlegast hafðu samband við þjónustu við viðskiptavini. (01)",
        "commonError": "Villa á sér stað. Vinsamlegast hafðu samband við þjónustu við viðskiptavini."
    },
    "settlement_Easy_and_convenient": "Auðvelt og þægilegt",
    "settlement_Great_deal": "Mikið",
    "settlement_Safe_and_secure": "Öruggt og öruggt",
    "settlement_Autopay_service_regulation": "Reglugerð um sjálfstýringu þjónustu",
    "settlement_Read": "Lestu",
    "settlement_No_coupon": "Enginn tiltækur afsláttarmiða",
    "settlement_Subtotal": "subtotal",
    "settlement_Coupon": "Afsláttarmiða",
    "settlement_TOTAL": "Alls",
    "settlement_promotion_tip": "Ekki er hægt að nota kynningartilboðið í tengslum við neinar afsláttarmiða",
    "settlement_coupon_tip": "Ekki er hægt að nota afsláttarmiða í tengslum við önnur kynningartilboð",
    "member_myFlow_noList": "Engin gögn ennþá",
    "detail_se_content": "Öruggur, auðveldur og þægilegur hátt. Þú getur sagt upp áskrift hvenær sem er",
    "Enter_Promo_code": "Kynningarnúmer",
    "Enter_Promo_Coupon": "Afsláttarmiða",
    "settlement_Not_used_coupon": "afsláttarmiða ekki notaður",
    "settlement_Available_coupon": "Laus",
    "settlement_Unavailable_coupon": "Ófáanlegt",
    "please_Enter_Promo_code": "Vinsamlegast sláðu inn kynningarnúmerið",
    "please_Select_Coupon_use": "Vinsamlegast veldu afsláttarmiða sem þú vilt nota.",
    "Buy_Now": "Kauptu núna",
    "Dont_Use_Any": "Ekki nota neitt",
    "settlement_confirm": "Staðfestu",
    "settlement_tips": "Staðfestu",
    "flowDetail_unsubscribe": "Afsakaðu",
    "flowDetail_unsubscribed": "Afskrá",
    "flowDetail_isCancelPackage": "Afsakaðu þennan pakka?",
    "flowDetail_confirmAgreementUnsubscribe": "Þú getur ekki haft mikið eftir að segja upp áskrift. Ertu viss um að þú viljir segja upp áskrift?",
    "flowDetail_cancel": "Hætta við",
    "flowDetail_cancelSuccess": "Afsakaðu áskrift með góðum árangri",
    "packages_detail_promotion": "Kynning",
    "orderTips":{
        "iDay" : "Dagur",
        "iDays" : "dagar",
        "iMonth" : "Mánuður",
        "iMonths" : "mánuðir",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol við fyrstu kaupin þín, Borgaðu %@money/%@periodSymbol síðar, Þú getur sagt upp áskrift hvenær sem er",
        'Monthly_discount':"Sparaðu %@saveMoney hvert %@period! Þú getur sagt upp áskrift hvenær sem er",
        'Ordinary_monthly_package':"Öruggur, auðveldur og þægilegur hátt. Þú getur sagt upp áskrift hvenær sem er",
        "AlreadyPurchased":'Því miður að þú getur aðeins gerst áskrifandi að einum gagnapakka um þessar mundir. Vinsamlegast afskráðu áskriftina af “%@” og gerast áskrifandi að því að öllum pakka sem þú vilt eftir að hann rennur út.',
        "Contract_recommendation_First":'<label>Með sjálfvirkri þjónustu, við fyrstu kaupin, borgaðu aðeins</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">Þú getur sagt upp áskrift hvenær sem er'
        +'<a class="btn">Gerast áskrifandi ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>Með sjálfvirkri þjónustu, borgaðu aðeins</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Þú getur sagt upp áskrift hvenær sem er'
        +'<a class="btn">Gerast áskrifandi ></a></p>',
        "Contract_recommendation_General":"<label>Með sjálfstýringu þjónustu</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Öruggur, auðveldur og þægilegur hátt. Þú getur sagt upp áskrift hvenær sem er'
        +'<a href="javascript:;" class="btn">Gerast áskrifandi ></a></p>',
        'BanlanceDoubleCheck':'Ertu viss um að þú viljir borga með jafnvægi?',
    },
    feedback: {
        title: "ábendingar",
        placeholder: "Vinsamlegast komdu inn í landið sem þú vilt heimsækja eða aðrar spurningar og við munum uppfylla þarfir þínar eins fljótt og auðið er!",
        submit: "Senda inn",
        submit_success: "Senda inn með góðum árangri",
        other_opinions: "Önnur skoðunir",
    },
    view_country_input: 'Vinsamlegast sláðu inn reikninginn þinn',
    "select_package": {
        "title": "Velja Gögn",
        "allPackage": "Öll Gögn",
        "type": "Tegund",
        "flow": "Gögn",
        "month_package": "Mánaðarskipulag",
        "flow_package": "Gagnapakki",
        "time": "Lengd",
        "period": "Hringrás",
        "auto_debit": "Info Sjálfvirkra Greiðsla",
        "auto_subscribe": "Sjálfvirk Framlenging",
        "detail": "Gögn Smáatriðnir",
        "carrier": "Stuðnuðir Reiknir",
        "country": "Þekkt Lönd",
        "notice": "Kaupagúð"
    }
}